import { combineReducers } from 'redux';

import aerospace from './aerospaceReducer';
import geofences from './geofencesReducer';
import obstacles from './obstaclesReducer';
import elevationHazards from './elevationHazardsReducer';
import orders from './ordersReducer';
import tools from './toolsReducer';
import ui from './uiReducer';
import orderTrackWS from './orderTrackWsReducer';
import aerospaceWS from './aerospaceWsReducer';
import uav from './uavReducer';
import routePlanner from './routePlannerReducer';
import bom from './bomReducer';
import { liveAircraftReducer } from './liveAircraftReducer';
import { devReducer } from './devReducer';
import adminReducer from './adminReducer';
import flightTestPlansReducer from './flightTestPlanReducers';
import flightCardReducer from './flightCardReducer';
import cassetteReducer from './cassettesReducer';
import unavailableWindowsReducer from './unavailableWindowsReducer';
import merchantDeviceReducer from './merchantDeviceReducer';

const rootReducer = combineReducers({
  aerospace,
  geofences,
  obstacles,
  elevationHazards,
  orders,
  tools,
  ui,
  orderTrackWS,
  aerospaceWS,
  uav,
  routePlanner,
  bom,
  liveAircraft: liveAircraftReducer,
  admin: adminReducer,
  dev: devReducer,
  flightTestPlans: flightTestPlansReducer,
  flightCards: flightCardReducer,
  cassettes: cassetteReducer,
  unavailableWindows: unavailableWindowsReducer,
  merchantDevices: merchantDeviceReducer,
});

export default rootReducer;
